'use client';

import type { FC, JSX } from 'react';
import React, { useEffect } from 'react';
import { useProductPageContext } from '@/components/productPageContext/ProductPageContext';
import SuspenseFallbackComponent from '@/components/SuspenseFallbackComponent/SuspenseFallbackComponent';
import { usePathname, useSearchParams } from 'next/navigation';

const ProductPageLoadingWrapper: FC = (): JSX.Element => {
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const { isLoading, setIsLoading } = useProductPageContext();

  useEffect(() => {
    setIsLoading(false);
  }, [pathName, searchParams]);

  return isLoading ? <SuspenseFallbackComponent logoOnly fixedPosition /> : <></>;
};

export default ProductPageLoadingWrapper;
